import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import RequireAuth from './components/RequireAuth';
import GlobalLayout from './components/layout/GlobalLayout';
import LoginPage from './pages/auth/LoginPage';
import ChatPage from './pages/chat/ChatPage';
import UserListPage from './pages/users/UserListPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes (no authentication required) */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes (authentication required) */}
        <Route element={<RequireAuth />}>
          <Route element={<GlobalLayout />}>
            <Route path="/" element={<ChatPage />} />
            <Route path="/channels/:channelId" element={<ChatPage />} />
            <Route path="/users" element={<UserListPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
